// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';

const snjPrimaryBtnStyle = css`
  color: ${(props) => props.theme.colorPalette.black};
  font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  text-align: center;
  border: none;
  background-size: 400% 50%;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  background-image: linear-gradient(
    147deg,
    #c1b3fe,
    #c1b3fe,
    #c1b3fe,
    #dfb3fe,
    #ffb3df,
    #ffb2c0,
    #ffd9b4
  );
  &:hover {
    background-position: 90% 0;
    -moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    background-size: 170%;
  }

  &:focus {
    outline: none;
  }
`;
const tcpPrimaryBtnStyle = css`
  background: rgb(255, 255, 255);
  color: rgb(74, 74, 74);
  border: 1px solid ${(props) => props.theme.colors.BUTTON.BLUE.BORDER};
  &:hover {
    ${(props) =>
      !props.disabled ? `background: ${props.theme.colorPalette.blue.C900}; color: white;` : ''}
  }
  &:hover:not([disabled]) {
    background: ${(props) => props.theme.colorPalette.blue.C900};
    color: white;
  }
`;
const pjpPrimayBtnStyle = css`
  ${tcpPrimaryBtnStyle}
  background-color: white;
  color: ${(props) => props.theme.colors.PRIMARY_BUTTON_COLOR};

  border-radius: 4px;
  &:hover {
    background-color: ${(props) => props.theme.colors.PRIMARY_BUTTON_COLOR};
    color: white;
  }
  &:hover:not([disabled]) {
    background-color: ${(props) => props.theme.colors.PRIMARY_BUTTON_COLOR};
  }
`;
const gymPrimayBtnStyle = css`
  ${tcpPrimaryBtnStyle}
  border-radius: 25.5px;
`;
const secondaryBtnStyle = (props) =>
  props.brand !== 'snj' && props.isBundleProduct === false
    ? `
    background: ${props.theme.colorPalette.blue.C900};
    color: white;
    border: 1px solid ${props.theme.colors.BUTTON.BORDER};
  `
    : '';

export const SubmitButtonWrapper = Styled.div`
  &.tile-redesign {
    margin-top: auto;
  }
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};

  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    min-height: 51px;
    display: flex;
    justify-content: flex-start;
  }
`;

export const SubmitButton = Styled.button`
  cursor: pointer;
  text-transform: uppercase;
  min-height: 42px;
  letter-spacing: 1px;
  font-size: 14px;
  min-width: 40px;
  font-family: Nunito;
  font-weight: 800;
  width: 100%;
  margin-top: 3px;
  padding: 15px 20px;
  ${(props) =>
    props.isHlp &&
    `
    position: absolute;
    bottom: 8px;
    width: 220px;
  `}

  ${(props) => (props.isPLP ? 'margin-top:0;' : '')}
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: ${(props) => (props.isHlp ? '128px' : '100%')}
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    width: ${(props) => (props.isHlp ? '230px' : '100%')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => (props.isPLP ? 'display: none;' : '')}

    &.display-inline-block {
      display: inline-block;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    &.reveal-atb-button {
      box-sizing: border-box;
      display: inline-block;
      min-height: 0;
      max-height: 0;
      padding: 0;
      overflow: hidden;
      transition: all 0.3s ease-in-out, border 0.1s ease-in-out;
    }
  }

  ${(props) =>
    props.brand === 'tcp' &&
    css`
      ${tcpPrimaryBtnStyle}
    `}
    ${(props) =>
      props.brand === 'snj' &&
      css`
        ${snjPrimaryBtnStyle}
      `}
    ${(props) =>
      props.brand === 'gym' &&
      css`
        ${gymPrimayBtnStyle}
      `}


  color: ${(props) => (props.isBundleProduct === true ? 'white' : '')};
  background-color: ${(props) =>
    props.isBundleProduct === true
      ? props.theme.brandSpecificStyles.PRODUCT_LISTING_BRAND_SPECIFIC_COLOR
      : 'white'};
      ${(props) =>
        props.brand === 'pjp' &&
        css`
          ${pjpPrimayBtnStyle}
        `}


  &[disabled] {
    opacity: 0.5;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${secondaryBtnStyle}
    font-size: 12px;
    padding: 0;
    ${(props) =>
      props.brand === 'pjp' &&
      css`
        ${pjpPrimayBtnStyle}
        padding: 0;
      `}
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    ${secondaryBtnStyle}
    padding: 8px 20px;
    ${(props) =>
      props.brand === 'pjp' &&
      css`
        ${pjpPrimayBtnStyle}
      `}
  }
`;
SubmitButton.displayName = 'SubmitButton';

export const AtbIcon = Styled.button`
  cursor: pointer;
  background-size: contain;
  height: auto;
  width: auto;
  border: none;
  padding: 0;
  bottom: 10px;
  right: 16px;
    ${(props) =>
      props.isHeroProduct &&
      `
      @media ${props.theme.mediaQuery.small} {
        height: 42px;
  }
      @media ${props.theme.mediaQuery.medium} {
     height: 51px;
  }   
  `}
  ${(props) =>
    props.isHlp &&
    `
    position: absolute;
  `}
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    right: 8px;
  }
  background-color: ${(props) => props.theme.colors.WHITE};
  @media ${(props) => props.theme.mediaQuery.small} {
    bottom: 4px;
  }
  img{
    @media ${(props) => props.theme.mediaQuery.small} {
      height: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 42px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 40px;
    }
  }
`;
AtbIcon.displayName = 'SubmitButtonIcon';
